<template>
  <div class="page loading bg-blue loader">

  </div>
</template>
<script>
  export default {
    name: 'loader'
  }
</script>